<template>
  <div>
    <a-card :bordered="false" :bodyStyle="tstyle">
      <div class="table-page-search-wrapper" v-if="hasPerm('inquirymanage:page')">
        <a-form layout="inline">
          <a-row :gutter="48">
            <a-col :md="8" :sm="24">
              <a-form-item label="提交时间">
                <a-date-picker style="width: 100%" placeholder="请选择提交时间" allow-clear @change="onChangectstamp" />
              </a-form-item>
            </a-col>
            <a-col :md="8" :sm="24">
              <a-form-item label="问诊类型">
                <!-- <a-input v-model="queryParam.treattype" allow-clear placeholder="请输入问诊类型(0-图文问诊1-健康咨询2-视频问诊)"/> -->
                <a-select v-model="queryParam.treatType" allow-clear placeholder="请选择问诊类型" :options="treattype">
                </a-select>
              </a-form-item>
            </a-col>
            <a-col :md="8" :sm="24">
              <a-form-item label="接诊类型">
                <!-- <a-input v-model="queryParam.treattype" allow-clear placeholder="请输入问诊类型(0-图文问诊1-健康咨询2-视频问诊)"/> -->
                <a-select v-model="queryParam.rcStatus" allow-clear placeholder="请选择接诊类型" :options="rcStatus">
                </a-select>
              </a-form-item>
            </a-col>
            <a-col :md="8" :sm="24">
              <a-form-item label="订单编号">
                <a-input v-model="queryParam.orderId" allow-clear placeholder="请输入订单编号" />
              </a-form-item>
            </a-col>
            <template v-if="advanced">
              <a-col :md="8" :sm="24">
                <a-form-item label="姓名">
                  <a-input v-model="queryParam.name" allow-clear placeholder="请输入姓名" />
                </a-form-item>
              </a-col>
              <a-col :md="8" :sm="24">
                <a-form-item label="医生姓名">
                  <a-input v-model="queryParam.drName" allow-clear placeholder="请输入医生姓名" />
                </a-form-item>
              </a-col>
              <a-col :md="8" :sm="24">
                <a-form-item label="手机号">
                  <a-input v-model="queryParam.mobile" allow-clear placeholder="请输入手机号" />
                </a-form-item>
              </a-col>
            </template>
            <a-col :md="8" :sm="24">
              <span class="table-page-search-submitButtons">
                <a-button type="primary" @click="$refs.table.refresh(true)">查询</a-button>
                <a-button style="margin-left: 8px" @click="() => queryParam = {}">重置</a-button>
                <a @click="toggleAdvanced" style="margin-left: 8px">
                  {{ advanced ? '收起' : '展开' }}
                  <a-icon :type="advanced ? 'up' : 'down'" />
                </a>
              </span>
            </a-col>
          </a-row>
        </a-form>
      </div>
    </a-card>
    <a-card :bordered="false">
      <s-table ref="table" :columns="columns" :data="loadData" :alert="options.alert" :rowKey="(record) => record.id"
        :rowSelection="options.rowSelection">
        <template class="table-operator" slot="operator" v-if="hasPerm('inquirymanage:add')">
          <x-down v-if="hasPerm('inquirymanage:export')" ref="batchExport" @batchExport="batchExport" />
        </template>


        <span slot="treattype" slot-scope="text, record">
          {{record.treattype == '0'? '图文问诊' : record.treattype == '1'? '健康咨询' : record.treattype == '2'? '视频问诊' : '' }}
        </span>
        <span slot="recdoctorname" slot-scope="text, record">
          {{ record.recdoctorname == null ? '——' : record.recdoctorname }}
        </span>
        <span slot="roomid" slot-scope="text, record">
          {{ record.roomid == null ? '—— ——' : record.roomid }}
        </span>
        <span slot="patientsex" slot-scope="text, record">
          {{record.patientsex == '1'? '男' : '女' }}
        </span>
        <span slot="rcStatus" slot-scope="text, record">
          {{ record.rcStatus == '0'? '待接诊' : record.rcStatus == '1'? '接诊中' : record.rcStatus == '2'? '已接诊' : '' }}
        </span>
        <!--  -->
        <span slot="action" slot-scope="text, record">
          <a @click="$refs.addForm.add(record)" style="margin-right:10px">详情</a>
          <a v-if="record.treattype == 0  && record.rcStatus == 2  " @click="exportRecord(record)">导出聊天记录</a>
          <a v-if="record.treattype == 2  && record.rcStatus == 2  " @click="seeVideoFile(record)">查看视频文件</a>
        </span>
      </s-table>
      <!-- 视频对话框 -->
      <a-modal v-model="visible" title="查看视频文件" :footer="null">
        <p v-for="(item,index) in videoFile" :key="index"><a @click="seeVideo(item.fileUrl)"><span
              style="padding-right:15px">视频时长：{{ changtime(item.duration) }}</span> 查看视频文件{{index + 1}}</a></p>
      </a-modal>
      <a-modal v-model="visibleFile" :width="820" title="查看视频文件" :footer="null" @cancel="cancel">
        <video v-if="isFile" width="780" height="500" controls autoplay :src="filePath" disablePictureInPicture></video>
      </a-modal>
      <add-form ref="addForm" @ok="handleOk" />
      <edit-form ref="editForm" @ok="handleOk" />
    </a-card>
  </div>
</template>
<script>
  import { STable, XDown } from '@/components'
  import moment from 'moment'
  import { inquirymanagePage, inquirymanageDelete, inquirymanageExport , exportRecord , exportFile } from '@/api/modular/interhospital/inquirymanage/inquirymanageManage'
  import addForm from './addForm.vue'
  import editForm from './editForm.vue'
  export default {
    components: {
      STable,
      addForm,
      editForm,
      XDown
    },
    data () {
      return {
        // 视频文件对话框
        visible : false,
        visibleFile : false,
        filePath : '',
        isFile : true,
        // 高级搜索 展开/关闭
        advanced: false,
        // 查询参数
        queryParam: {},
        // 表头
        columns: [
          {
            title: '提交时间',
            align: 'center',
            dataIndex: 'ctstamp'
          },
          {
            title: '问诊类型',
            align: 'center',
            dataIndex: 'treattype',
            scopedSlots: { customRender: 'treattype' },
          },
          {
            title: '姓名',
            align: 'center',
            dataIndex: 'patientname'
          },
          {
            title: '性别',
            align: 'center',
            dataIndex: 'patientsex',
            scopedSlots: { customRender: 'patientsex' },
          },
          {
            title: '年龄',
            align: 'center',
            dataIndex: 'patientage'
          },
          {
            title: '科室名称',
            align: 'center',
            dataIndex: 'deptname'
          },
          {
            title: '医生姓名',
            align: 'center',
            dataIndex: 'recdoctorname',
            scopedSlots: { customRender: 'recdoctorname' },
          },
          {
            title: '费用',
            align: 'center',
            dataIndex: 'pafeeall'
          },
          {
            title: '房间号',
            align: 'center',
            dataIndex: 'roomid',
            scopedSlots: { customRender: 'roomid' },
          },
          {
            title: '订单编号',
            align: 'center',
            dataIndex: 'orderId',
          },
          {
            title: '接诊类型',
            align: 'center',
            dataIndex: 'rcStatus',
            scopedSlots: { customRender: 'rcStatus' },
          }
        ],
        // 问诊类型
        treattype : [
          {
            value: '0',
            label: '图文问诊',
          },
          {
            value: '1',
            label: '健康咨询',
          },
          {
            value: '2',
            label: '视频问诊',
          },
        ],
        // 接诊状态
        rcStatus : [
          {
            value: '0',
            label: '待接诊',
          },
          {
            value: '1',
            label: '接诊中',
          },
          {
            value: '2',
            label: '已接诊',
          },
        ],
        videoFile : '',
        tstyle: { 'padding-bottom': '0px', 'margin-bottom': '10px' },
        // 加载数据方法 必须为 Promise 对象
        loadData: parameter => {
          return inquirymanagePage(Object.assign(parameter, this.queryParam)).then((res) => {
            return res.data
          })
        },
        selectedRowKeys: [],
        selectedRows: [],
        options: {
          alert: { show: true, clear: () => { this.selectedRowKeys = [] } },
          rowSelection: {
            selectedRowKeys: this.selectedRowKeys,
            onChange: this.onSelectChange
          }
        }
      }
    },
  created() {
      console.log(this.$router)
      if (this.hasPerm('inquirymanage:edit') || this.hasPerm('inquirymanage:delete')) {
        this.columns.push({
          title: '操作',
          width: '150px',
          dataIndex: 'action',
          scopedSlots: { customRender: 'action' }
        })
      }
    },
    methods: {
      moment,
      changtime(value){
          var secondTime = parseInt(value / 1000);
          if(secondTime < 10){
            return '00:0' +  secondTime
          }
          var minuteTime = 0;
          var hourTime = 0;
          if(secondTime >= 60){
              minuteTime = parseInt(secondTime / 60);
              secondTime = parseInt(secondTime % 60);
              if(minuteTime >= 60){
                  hourTime = parseInt(minuteTime / 60);
                  minuteTime = parseInt(minuteTime % 60);
                  
              }
          }
          var resule = "" + parseInt(secondTime)
          if(resule < 10){
            resule = '0' + resule
          }
          if(minuteTime > 0 && minuteTime < 10){
              resule = "0" + parseInt(minuteTime) + ':' + resule
          }else{
            resule = "" + parseInt(minuteTime) + ':' + resule
          }

          if(hourTime > 0 && hourTime < 10){
              resule = '0' + parseInt(hourTime) + ':' + resule
          }else {
              resule = '' + parseInt(hourTime) + ':' + resule
          }
          return resule
      },
      /**
       * 查询参数组装
       */
      switchingDate () {
        const queryParamctstamp = this.queryParam.ctstampDate
        if (queryParamctstamp != null) {
            this.queryParam.ctstamp = moment(queryParamctstamp).format('YYYY-MM-DD')
            if (queryParamctstamp.length < 1) {
                delete this.queryParam.ctstamp
            }
        }
        const obj = JSON.parse(JSON.stringify(this.queryParam))
        return obj
      },
      /**
       * 单个删除
       */
      singleDelete (record) {
        const param = [{ 'id': record.id }]
        this.inquirymanageDelete(param)
      },
      /**
       * 批量删除
       */
      batchDelete () {
        const paramIds = this.selectedRowKeys.map((d) => {
            return { 'id': d }
        })
        this.inquirymanageDelete(paramIds)
      },
      inquirymanageDelete (record) {
        inquirymanageDelete(record).then((res) => {
          if (res.success) {
            this.$message.success('删除成功')
            this.$refs.table.clearRefreshSelected()
          } else {
            this.$message.error('删除失败') // + res.message
          }
        })
      },
      toggleAdvanced () {
        this.advanced = !this.advanced
      },
      onChangectstamp(date, dateString) {
        this.queryParam.ctstamp = dateString
      },
      /**
       * 批量导出
       */
      batchExport () {
        const paramIds = this.selectedRowKeys.map((d) => {
            return { 'id': d }
        })
        inquirymanageExport(paramIds).then((res) => {
            this.$refs.batchExport.downloadfile(res)
        })
      },
      handleOk () {
        this.$refs.table.refresh()
      },
      onSelectChange (selectedRowKeys, selectedRows) {
        this.selectedRowKeys = selectedRowKeys
        this.selectedRows = selectedRows
      },
      // 查看视频文件
      seeVideoFile(record){
        console.log(record);
        let params = {
          roomId : record.roomid
        }
        exportFile(params).then(res=>{
          console.log(res);
          this.visible = true;
          if(res.code == 200){
            this.videoFile = res.data;
          }else{
            this.$message.error(res.message)
          }
        })

      },
      seeVideo(path){
        this.isFile = true;
        this.filePath = path;
        this.visible = false;
        this.visibleFile = true;
      },
      cancel(){
        this.isFile = false;
        this.visible = true;
      },
      //导出聊天文件
      exportRecord(record){
        console.log(record);
        let params = {
          roomId : record.roomid
        }

        exportRecord(params).then(res=>{
          const blob = new Blob([res.data],{
            type : 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
          })
          const url = window.URL.createObjectURL(blob);
          const ele = document.createElement('a');
          ele.style.display = 'none';
          ele.href = url;
          const fileName = '聊天记录';
          ele.setAttribute('download',fileName);
          document.querySelectorAll('body')[0].appendChild(ele);
          ele.click();
          ele.remove();
          console.log(res)
        })
      }
    }
  }
</script>
<style lang="less" scoped>
  .table-operator {
    margin-bottom: 18px;
  }
  button {
    margin-right: 8px;
  }
  
</style>
